import QuestionsIndex from "@/views/questions/QuestionsIndex.vue";
import AddQuestion from "@/views/questions/AddQuestion.vue";
import EditQuestion from "@/views/questions/EditQuestion.vue";
import AddQuestionForm from "@/views/question-forms/AddQuestionForm.vue";

export default [
  {
    path: "/questions",
    name: "questions.index",
    component: QuestionsIndex,
    meta: { 
      title: "questions.indexTitle", 
      requiresAuth: true ,
      requiredPerm: "questions.display"
    },
    children: [
      {
        path: "create",
        name: "questions.create",
        component: AddQuestion,
        meta: { 
          title: "questions.addTitle", 
          requiresAuth: true ,
          requiredPerm: "questions.create"
        },
      },
      {
        path: ":id/edit",
        name: "questions.edit",
        component: EditQuestion,
        meta: { 
          title: "questions.editTitle", 
          requiresAuth: true,
          requiredPerm: "questions.update"
        },
        props: true,
      },
    ],
  },
  {
    path: "/question-forms/create",
    name: "question-forms.create",
    component: AddQuestionForm,
    meta: { 
      title: "questionForm.createTitle", 
      requiresAuth: true,
      requiredPerm: "question_forms.create"
    },
  },
];
